/* eslint-disable */
import dayjs from "dayjs";
import * as antdLocale from "antd/locale/en_US";
import * as dayjsLocale from "dayjs/locale/en";
import React, { Component } from "react";
import "./css/style.css";

import {
  DemoData,
  Scheduler,
  SchedulerData,
  ViewType,
  wrapperFun,
} from "./index";
let maindata = 0

class ResourceBasicScheduler extends Component {
  constructor(props) {
    super(props);

    const { events, resources, callbackSchedulerData } = props;
    console.log(events, "Ashs");
    console.log(resources, "ashs");
    const schedulerData = new SchedulerData(
      dayjs(),
      ViewType.Week,
      false,
      false,
      {
        besidesWidth: 300,
        dayMaxEvents: 99,
        weekMaxEvents: 9669,
        monthMaxEvents: 9669,
        quarterMaxEvents: 6599,
        yearMaxEvents: 9956,
        customMaxEvents: 9965,
        eventItemPopoverTrigger: "click",
        schedulerContentHeight: "100%",
        calendarPopoverEnabled: false,
      }
    );

    schedulerData.setSchedulerLocale(dayjsLocale);
    schedulerData.setCalendarPopoverLocale(antdLocale);
    schedulerData.setResources(resources);
    schedulerData.setEvents(events);
    this.state = {
      viewModel: schedulerData,
      events: props.events,
    };

    if (callbackSchedulerData) callbackSchedulerData(schedulerData);
  }

  componentDidUpdate(prevProps) {
    // Check if events or resources have changed
    if (
      prevProps.events !== this.props.events ||
      prevProps.resources !== this.props.resources
    ) {
      const { events, resources } = this.props;
      const { viewModel } = this.state;
  
      // Update scheduler data with new events and resources
      viewModel.setResources(resources);
      viewModel.setEvents(events);
  
      // Update the state to trigger re-render
      this.setState({
        viewModel,
        events,
      });
    }
  }
  

  render() {
    const { viewModel } = this.state;
    return (
      <Scheduler
        schedulerData={viewModel}
        prevClick={this.prevClick}
        nextClick={this.nextClick}
        onSelectDate={this.onSelectDate}
        onViewChange={this.onViewChange}
        eventItemClick={this.eventClicked}
        viewEventClick={this.ops1}
        viewEventText="Ops 1"
        viewEvent2Text="Ops 2"
        viewEvent2Click={this.ops2}
        updateEventStart={this.updateEventStart}
        updateEventEnd={this.updateEventEnd}
        moveEvent={this.moveEvent}
        newEvent={this.newEvent}
        onScrollLeft={this.onScrollLeft}
        onScrollRight={this.onScrollRight}
        onScrollTop={this.onScrollTop}
        onScrollBottom={this.onScrollBottom}
        toggleExpandFunc={this.toggleExpandFunc}
      />
    );
  }
  prevClick = (schedulerData) => {
    const { callBackPrevClick, callbackSchedulerData } = this.props;
    const { events } = this.state;
    schedulerData.prev();
    schedulerData.setEvents(events);
    callBackPrevClick(schedulerData);
    callbackSchedulerData(schedulerData);
    this.setState({ viewModel: schedulerData });
  };

  nextClick = (schedulerData) => {
    const { callBackNextClick, callbackSchedulerData } = this.props;
    const { events } = this.state;
    schedulerData.next();
    schedulerData.setEvents(events);
    callBackNextClick(schedulerData);
    callbackSchedulerData(schedulerData);
    this.setState({ viewModel: schedulerData });
  };

  onViewChange = (schedulerData, view) => {
    const { events } = this.state;
    const start = new Date();
    schedulerData.setViewType(
      view.viewType,
      view.showAgenda,
      view.isEventPerspective
    );
    schedulerData.setEvents(events);
    this.setState({ viewModel: schedulerData });
    function secondsBetween(date1, date2) {
      const diff = Math.abs(date1.getTime() - date2.getTime());
      return diff / 1000;
    }

    console.log("Elapsed seconds: " + secondsBetween(start, new Date()));
  };

  onSelectDate = (schedulerData, date) => {
    const { events } = this.state;
    schedulerData.setDate(date);
    schedulerData.setEvents(events);
    this.setState({
      viewModel: schedulerData,
    });
  };

  eventClicked = (schedulerData, event) => {
    const { callBackEventClicked } = this.props;
    // alert(
    //   `You just clicked an event: {id: ${event.id}, title: ${event.title}}`
    // );
    callBackEventClicked(event);
  };

  ops1 = (schedulerData, event) => {
    alert(
      `You just executed ops1 to event: {id: ${event.id}, title: ${event.title}}`
    );
  };

  ops2 = (schedulerData, event) => {
    alert(
      `You just executed ops2 to event: {id: ${event.id}, title: ${event.title}}`
    );
  };

  newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {
    // if (confirm(`Do you want to create a new event? {slotId: ${slotId}, slotName: ${slotName}, start: ${start}, end: ${end}, type: ${type}, item: ${item}}`)) {
    //   let newFreshId = 0;
    //   schedulerData.events.forEach(item => {
    //     if (item.id >= newFreshId) newFreshId = item.id + 1;
    //   });

    //   let newEvent = {
    //     id: newFreshId,
    //     title: 'New event you just created',
    //     start: start,
    //     end: end,
    //     resourceId: slotId,
    //     bgColor: 'purple',
    //   };
    //   schedulerData.addEvent(newEvent);
    //   this.setState({ viewModel: schedulerData });
    // }

    const { callBackAddEvent } = this.props;
    const data = {
      slotId,
      slotName,
      start,
      end,
      type,
      item,
    };
    callBackAddEvent(data);
    // let newEvent = {
    //       id: maindata++,
    //       title: 'New event you just created',
    //       start: start,
    //       end: end,

    //       resourceId: slotId,
    //       bgColor: 'purple',
    //     };
    // schedulerData.addEvent(newEvent);
    this.setState({ viewModel: schedulerData });
  };

  updateEventStart = (schedulerData, event, newStart) => {
    if (
      confirm(
        `Do you want to adjust the start of the event? {eventId: ${event.id}, eventTitle: ${event.title}, newStart: ${newStart}}`
      )
    ) {
      schedulerData.updateEventStart(event, newStart);
    }
    this.setState({ viewModel: schedulerData });
  };

  updateEventEnd = (schedulerData, event, newEnd) => {
    if (
      confirm(
        `Do you want to adjust the end of the event? {eventId: ${event.id}, eventTitle: ${event.title}, newEnd: ${newEnd}}`
      )
    ) {
      schedulerData.updateEventEnd(event, newEnd);
    }
    this.setState({ viewModel: schedulerData });
  };

  moveEvent = (schedulerData, event, slotId, slotName, start, end) => {
    if (
      confirm(
        `Do you want to move the event? {eventId: ${event.id}, eventTitle: ${event.title}, newSlotId: ${slotId}, newSlotName: ${slotName}, newStart: ${start}, newEnd: ${end}`
      )
    ) {
      schedulerData.moveEvent(event, slotId, slotName, start, end);
      this.setState({ viewModel: schedulerData });
    }
  };

  onScrollRight = (schedulerData, schedulerContent, maxScrollLeft) => {
    const { events } = this.state;
    if (schedulerData.ViewTypes === ViewType.Day) {
      schedulerData.next();
      schedulerData.setEvents(events);
      this.setState({ viewModel: schedulerData });

      schedulerContent.scrollLeft = maxScrollLeft - 10;
    }
  };

  onScrollLeft = (schedulerData, schedulerContent) => {
    const { events } = this.state;
    if (schedulerData.ViewTypes === ViewType.Day) {
      schedulerData.prev();
      schedulerData.setEvents(events);
      this.setState({ viewModel: schedulerData });

      schedulerContent.scrollLeft = 10;
    }
  };

  onScrollTop = () => console.log("onScrollTop");

  onScrollBottom = () => console.log("onScrollBottom");

  toggleExpandFunc = (schedulerData, slotId) => {
    schedulerData.toggleExpandStatus(slotId);
    this.setState({ viewModel: schedulerData });
  };
}

export default wrapperFun(ResourceBasicScheduler);
